import React, { createContext, useContext, useMemo } from 'react';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';

const TECH_TEAM_GROUP = 'tech-team';

interface IPromptsContext {
    canEdit: boolean;
    canPublish: boolean;
    canArchive: boolean;
}

const PromptsContext = createContext<IPromptsContext | null>(null);

export const PromptsProvider = ({ children }: { children: React.ReactNode }) => {
    const { data: currentUser } = useGetCurrentUserQuery();

    const canEdit = Boolean(currentUser);
    const canPublish = Boolean(
        currentUser?.groups?.includes(TECH_TEAM_GROUP) ||
        currentUser?.username === TECH_TEAM_GROUP,
    );
    const canArchive = Boolean(currentUser);

    const value = useMemo(
        () => ({ canEdit, canPublish, canArchive }),
        [canEdit, canPublish, canArchive],
    );

    return <PromptsContext.Provider value={value}>{children}</PromptsContext.Provider>;
};

export const usePrompts = () => {
    const ctx = useContext(PromptsContext);
    if (!ctx) {
        throw new Error('usePrompts must be used within PromptsProvider');
    }
    return ctx;
};
